<section #popupContainer class="popup-container" [formGroup]="form">
    <!-- selectors section -->
    <div class="content-container" *ngIf="!message?.isInformed">
      <div class="header">
        <h3>{{'DASHBOARD.MESSAGES.POPUP.SEND_TO' | translate}}</h3>
      </div>
      <div class="selectors">
        <div class="selector">
          <app-custom-form-control
            [defaultControlTemplate]="{text : 'DASHBOARD.MESSAGES.POPUP.CONTROLS.IN_APP' | translate}"
            formControlName="appNotify"
          ></app-custom-form-control>
        </div>
        <div class="selector">
          <app-custom-form-control
            [defaultControlTemplate]="{text : 'DASHBOARD.MESSAGES.POPUP.CONTROLS.IN_MAIL' | translate}"
            formControlName="emailNotify"
          ></app-custom-form-control>
        </div>
      </div>
    </div>
    <!-- message title section -->
    <div class="content-container">
      <div class="content" *ngIf="message?.title">
        <app-input-field 
          [label]="'DASHBOARD.MESSAGES.POPUP.MESSAGE_TITLE' | translate"
          formControlName="title">
        </app-input-field>
      </div>
    </div>
    <!-- message content section -->
    <div class="content-container">
      <div class="content">
        <label class="message-content" for="message-content">{{'DASHBOARD.MESSAGES.POPUP.MESSAGE_CONTENT' | translate}}</label>
        <textarea name="" id="message-content" cols="20" rows="10" formControlName="messageContent" matInput></textarea>
      </div>
    </div>
    <!-- replies section -->
    <div class="content-container">
        <div class="replies-header">
          <h3 [style.visibility]="messagesDetails.length > 0 ? 'visible' : 'hidden'">{{'DASHBOARD.MESSAGES.POPUP.REPLIES' | translate}}</h3>
          <app-shared-button-component
            [buttonName]="'DASHBOARD.MESSAGES.POPUP.ADD_NEW_REPLY' | translate"
            [caller]="onShowNewReplySection()">
            <app-svg-icon [icon]="IconsConstants.NOTEBOOK_ICON"></app-svg-icon>
          </app-shared-button-component>
        </div>
    </div>
    <!-- message details section -->
    <ng-container *ngFor="let message of messagesDetails">
      <div class="messages-container">
         <div class="messages-container-header">
          <div class="user-info">
            <app-svg-icon [icon]="IconsConstants.PERSON_ICON"></app-svg-icon>
            <span>{{message?.sender?.fullName}}</span>
          </div>
          <div class="time-period">
            <div class="card">
              <app-svg-icon [icon]="IconsConstants.BOLD_CLOCK_ICON"></app-svg-icon>
              <span>{{message.date | timeFormatter:SharedConstants.TIME_FORMAT_OPTIONS_12H}}</span>
            </div>
            <div class="card">
              <app-svg-icon [icon]="IconsConstants.BOLD_CALENDAR_ICON"></app-svg-icon>
              <span> {{(message?.date | dateFormatter : SharedConstants.SHORT_DATE_FORMAT)}}</span>
            </div>
          </div>
         </div>
         <div class="messages-container-content">
          <span>{{message?.content}}</span>
          <div class="img">
            <img *ngIf="message?.file && message.fileType == FileType.IMAGE" [src]="message?.file" alt="photo" />
          </div>
         </div>
      </div>
    </ng-container>
    <!-- new reply section -->
    <ng-container *ngIf="showNewReply">
      <!-- reply input section -->
      <div class="reply-section">
        <div class="header">
          <h3>{{'DASHBOARD.MESSAGES.POPUP.NEW_REPLY' | translate}}</h3>
        </div>
        <div class="content">
          <textarea name="" id="" cols="20" rows="10" formControlName="message" matInput></textarea>
          <app-error-validation-message [control]="form.get('message')" [errors]="form.get('message').errors"></app-error-validation-message>
        </div>
        <div class="content">
          <app-file-upload-control [isButtonElement]="true" [label]="'BUTTONS.ADD_ATTACHMENT' | translate" formControlName="file"></app-file-upload-control>
          <app-error-validation-message [control]="form.get('file')"  [errors]="form.get('file').errors"></app-error-validation-message>
        </div>
      </div>
      <div class="popup-buttons-container">
        <app-shared-button-component
          [buttonName]="'BUTTONS.CANCEL' | translate"
          [caller]="closePopupCallback()">
        </app-shared-button-component>
        <app-shared-button-component
          [buttonName]="'BUTTONS.SEND' | translate"
          [caller]="onSubmit()">
        </app-shared-button-component>
      </div>
    </ng-container>
</section>
